"use strict";

exports.__esModule = true;
exports.DEBUG_CONTENT_SYNC_MODE = void 0;
const DEBUG_CONTENT_SYNC_MODE = typeof window !== `undefined` && (process.env.GATSBY_DEBUG_CONTENT_SYNC === `true` || !!new URLSearchParams(window.location.search).get(`debug`));
exports.DEBUG_CONTENT_SYNC_MODE = DEBUG_CONTENT_SYNC_MODE;